import * as type from "../actions/types";

const initialState = {
  errors: [],
  loading: false,
  success: false,
  token: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case type.LOGIN_USER_PENDING:
      console.log("login user pending");
      return {
        ...state,
        ...initialState,
        loading: true,
        success: false,
        errors: [],
      };
    case type.LOGIN_USER_SUCCESS:
      console.log("login user success", action);
      return {
        ...state,
        loading: false,
        success: true,
        errors: [],
        token: action.payload.token,
      };
    case type.LOGIN_USER_FAILURE:
      console.log("login user failure");
      return {
        ...state,
        loading: false,
        success: false,
        errors: action.payload,
      };
    case type.LOGOUT_USER:
      console.log("logout user");
      return {
        ...state,
        ...initialState,
      };
    case type.CLEAR_LOGIN_USER:
      console.log("clearing login user");
      return {
        ...initialState,
      };
    default:
      return state;
  }
};
